export interface IBureauAutor {
    email: string;
    nome: string;
}

export interface IBureau {
    bureau: string;
    nome: string;
    created_at: string;
    created_by: IBureauAutor | null;
    /** Total da lista; vem só na primeira página. */
    full_count?: number;
}

/** Último Bureau recebido, para buscar a página seguinte. `created_at` vai como veio da API. */
export interface IBureauOffset {
    created_at: string;
    bureau: string;
}

export interface IBureauTenantResumo {
    tenant: number;
    codigo: string;
    /** Pode vir `null` ou string vazia — exibir só quando preenchido. */
    nome: string | null;
}

export interface IBureauTenant {
    bureautenant: string;
    tenant: IBureauTenantResumo;
    created_at: string;
    created_by: IBureauAutor | null;
}

export interface IBureauUsuario {
    bureauusuario: string;
    contaid: number;
    nome: string;
    /** Pode vir `null` ou string vazia — concatenar só se preenchido. */
    sobrenome: string | null;
    email: string;
    /** 0 = Administrador, 1 = Membro */
    nivel: number;
}

export interface IBureauMembro {
    bureaumembro: string;
    created_at: string;
    created_by: IBureauAutor | null;
    bureauusuario: IBureauUsuario;
}

export interface IBureauForm {
    bureau?: string;
    nome: string;
}

/** Estado de detalhe de um bureau, mantido no controller do index, indexado por bureau (UUID). */
export interface IBureauDetalhe {
    tenants: IBureauTenant[];
    membros: IBureauMembro[];
    tenantsCarregados: boolean;
    membrosCarregados: boolean;
    tenantsBusy: boolean;
    membrosBusy: boolean;
    novoTenantId: number | null;
    novoMembroEmail: string;
    adicionandoTenant: boolean;
    adicionandoMembro: boolean;
}

export const BUREAU_NIVEL_ADMINISTRADOR = 0;
export const BUREAU_NIVEL_MEMBRO = 1;
export const BUREAU_NOME_MAX_LENGTH = 128;
/** Itens por página nas listas paginadas da API: Bureaus e pessoas das equipes. */
export const BUREAU_TAMANHO_PAGINA = 20;
